import styled from 'styled-components';

export const InputContainer = styled.div`
  margin: 10px 0;
  height: 50px;
`;

export const StatusContainer = styled.div`
  margin-bottom: 16px;
`;

export const ClearContainer = styled.div`
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
`;
